import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  goodsLocationList: {
    rows: [],
    total: 0
  },
  goodsLocationMark: 0,
  xlsUrl: {},
  goodNumber: {}
}

const actions = {
  [types.GETGOODSLOCATIONLIST] (context, params) {
    http.fetch('/api/ycLocation/locationPageList', params).then(data => {
      context.commit(types.GETGOODSLOCATIONLIST, data)
    })
  },
  [types.SAVEGOODSLOCATION] (context, params) {
    http.fetch('/api/ycLocation/saveLocation', params).then(data => {
      context.commit(types.SAVEGOODSLOCATION, data)
    })
  },
  [types.DELGOODSLOCATION] (context, params) {
    http.fetch('/api/ycLocation/batchDeleteLocation', params).then(data => {
      context.commit(types.DELGOODSLOCATION, data)
    })
  },
  [types.IMPORTGOODSLOCATION] (context, params) {
    http.fetch('/api/ycLocation/importLocation', params).then(data => {
      context.commit(types.IMPORTGOODSLOCATION, data)
    })
  },
  [types.GETGOODSLOCATIONDETAILS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/ycLocation/selectLocationById', params).then(data => {
        context.commit(types.GETGOODSLOCATIONDETAILS, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.GETGOODSLOCATIONLIST] (state, data) {
    state.goodsLocationList = data.easyuiPage
    if (!data.locationTypeNumber) {
      state.goodNumber = {
        y: 0,
        w: 0
      }
    } else {
      state.goodNumber = data.locationTypeNumber
    }
  },
  [types.SAVEGOODSLOCATION] (state, data) {
    if (data.code === 200) {
      state.goodsLocationMark = 1
      vue.$message({
        showClose: true,
        message: '保存成功',
        type: 'success'
      })
    } else if (data.code === 500 && data.message === '库区不存在或已被删除') {
      state.goodsLocationMark = 4
    }
  },
  [types.DELGOODSLOCATION] (state, data) {
    if (data.code === 200) {
      state.goodsLocationMark = 1
      if (data.obj) {
        vue.$message({
          showClose: true,
          message: data.obj,
          type: 'warning'
        })
      } else {
        vue.$message({
          showClose: true,
          message: '删除成功',
          type: 'success'
        })
      }
    }
  },
  [types.IMPORTGOODSLOCATION] (state, data) {
    if (data.code !== 200) {
      state.goodsLocationMark = -1
      state.xlsUrl = {
        url: '',
        message: data.message
      }
      return false
    }
    if (data.obj) {
      state.xlsUrl = {
        url: data.obj
      }
      state.goodsLocationMark = 3
    } else {
      state.xlsUrl = {
        url: '',
        message: '供应商信息导入成功'
      }
      state.goodsLocationMark = 2
    }
  },
  [types.GETGOODSLOCATIONDETAILS] (state, data) {}
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/goodsLocation/index.js